import { useEffect, useRef, useState } from "react";

const useClickout = (initialState: boolean) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const elementRef = useRef<HTMLDivElement>(null);

  const [openedState, setOpenedState] = useState<boolean>(initialState);

  useEffect(() => {
    const handleClickoutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (triggerRef.current?.contains(target)) {
        setOpenedState((prev) => !prev);
        return;
      }

      if (!elementRef.current?.contains(target)) {
        setOpenedState(false);
      }
    };

    document.addEventListener("click", handleClickoutside, true);
    return () => document.removeEventListener("click", handleClickoutside, true);
  }, []);

  return {
    triggerRef,
    elementRef,
    openedState,
    setOpenedState,
  };
};

export default useClickout;
